import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  query getScreeningStats($filter: screeningCountAnalysisFilterInput!) {
    getScreeningCountAnalysis(filter: $filter) {
      totalSubjectCount
      screenedSubjectCount
      error {
        statusCode
        message
      }
    }
  }
`;

const initialState: TYPES.ScreeningCountAnalysisState = {
  result: null,
  error: null,
  loading: false
};

export const getScreeningStatsRequest = createAsyncThunk<
  TYPES.ScreeningCountAnalysis,
  {filter: TYPES.ScreeningCountAnalysisFilterInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'reading/get_screening_stats',
  async (
  params: {filter: TYPES.ScreeningCountAnalysisFilterInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.query({
        query: GRAPHQL,
        variables: params
      });
      return response.data.getScreeningCountAnalysis;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const getScreeningStatsSlice = createSlice({
  name: 'get_screening_stats',
  initialState: initialState,
  reducers: {
    getScreeningStatsClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(getScreeningStatsRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(getScreeningStatsRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(getScreeningStatsRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { getScreeningStatsClear } = getScreeningStatsSlice.actions;

export const getScreeningStats = createSelector(
  (state: RootState) => state.reading.getScreeningStats.result,
  (state: RootState) => state.reading.getScreeningStats.error,
  (state: RootState) => state.reading.getScreeningStats.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default getScreeningStatsSlice.reducer;